<template>
	<div>
		<div class="autosec-main-container relativeclass">
			<div class="auto-test-main-head">
				<div class="headtext d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center">
						<div class="pointer">
							<img
								class="pb-1"
								src="../../assets/icons/Reports/bckarrow.svg"
								alt=""
								@click="goTobackpage()"
							/>
						</div>
						<div class="heading ml-3">AutoGenerate Test</div>
					</div>
					<div class="d-flex justify-content-start mt-3">
						<b-button
							:class="
								getAutGenData.sections.length == 0
									? 'ags-disabledbtn mr-1'
									: 'addbtn mr-1'
							"
							v-if="updatebtn == false"
							@click="createSection()"
						>
							Create
						</b-button>
						<b-button
							class="addbtn"
							@click="(force = false), makeactive()"
							v-else
						>
							Create
						</b-button>
					</div>
				</div>
				<b-modal id="testsamename" centered hide-footer hide-header>
					<div
						class="modalheading d-flex align-items-center justify-content-between"
					>
						Caution
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div @click="closetestsamename()" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<hr />
					<div class="mt-3">
						<div class="testsamename-modal-text mt-2">
							<img src="../../assets/noteicon.svg" alt="" />

							<span class="ml-2"
								>Test
								<span class="testsamename-test">
									"{{ getAutGenData.testName }}"
								</span>
								is already exists in inactive list.
							</span>
						</div>
						<div class="testsamename-modal-text mt-3 mb-3">
							Do You want to "Activate The Test" "{{ getAutGenData.testName }}"?
							(or) Do you want to Add Test "{{ getAutGenData.testName }}" as New
							Test?
						</div>
						<b-form-radio-group
							class="caution-option activate-options-text"
							:options="updatedataoptions"
							value-field="item"
							text-field="name"
							disabled-field="notEnabled"
							v-model="updateData"
						></b-form-radio-group>

						<div class="d-flex align-items-center justify-content-end mt-3">
							<b-button
								:class="
									updateData == null
										? 'ags-disabledbtn  pl-3 pr-3'
										: 'addbtn  pl-3 pr-3'
								"
								@click="gotoparticularpage"
							>
								Next
							</b-button>
						</div>
					</div>
				</b-modal>
				<b-modal id="confirmationmodal" centered hide-footer hide-header>
					<div
						class="modalheading d-flex align-items-center justify-content-between"
					>
						Caution
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div @click="$bvModal.hide('confirmationmodal')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<hr />
					<div class="mt-3">
						<span class="ml-2"
							>Are you sure to make
							<span class="testsamename-test">
								"{{ getAutGenData.testName }}"
							</span>
							as a new test.
						</span>

						<div class="d-flex align-items-center justify-content-end mt-3">
							<b-button class="addbtn pl-3 pr-3" @click="makeactive()">
								OK
							</b-button>
						</div>
					</div>
				</b-modal>
				<b-modal id="inactivetests" centered hide-footer hide-header size="lg">
					<div
						class="modalheading d-flex align-items-center justify-content-between modal-text"
					>
						Caution
					</div>
					<div @click="$bvModal.hide('inactivetests')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>

					<hr />

					<div class="mt-3">
						<div class="testsamename-modal-text mt-2">
							<img src="../../assets/noteicon.svg" alt="" />

							<span class="ml-2 inactivetopicname-text"
								>Test
								<span class="testsamename-test">
									" {{ getAutGenData.testName }}"
								</span>
								with same test name is already exists in inactivelist.
							</span>
						</div>
						<div class="inactivetopicname-text mt-3 mb-3">
							Please confirm the test that you want to activate based on other
							details.
						</div>
					</div>

					<div
						:class="[
							{
								'testdata-size': true,
								'dynamic-height': activetest.length > 0,
							},
						]"
						:style="{ maxHeight: containerHeight }"
					>
						<div
							class="d-flex align-items-center"
							v-for="(i, index) in activetest"
							:key="index"
							@click="selectedtest = i"
							:class="
								selectedtest.testID == i.testID
									? 'inactive-selected-box'
									: 'inactivecust-detail-box'
							"
						>
							<div class="pointer mt-3" style="width: 100%">
								<div class="d-flex relativeclass tp-gridcont flexgrid mb-2">
									<div style="width: 95%" class="d-flex">
										<div class="d-flex flex-column" style="width: 50%">
											<div class="tp-text tp-cardhead ml-1">
												{{ i.name }}
											</div>
											<div>
												<span
													:class="
														i.difficultyLevel == 'Easy'
															? 'pinktext'
															: i.difficultyLevel == '--'
															? 'disabletext'
															: 'greytext'
													"
													>Easy / </span
												><span
													:class="
														i.difficultyLevel == 'Medium'
															? 'pinktext'
															: i.difficultyLevel == '--'
															? 'disabletext'
															: 'greytext'
													"
													>Medium </span
												><span
													:class="
														i.difficultyLevel == 'Difficult'
															? 'pinktext'
															: i.difficultyLevel == '--'
															? 'disabletext'
															: 'greytext'
													"
													>/ Difficult</span
												>
											</div>
										</div>
										<div class="d-flex flex-column" style="width: 10%">
											<span class="tp-cardhead">Sections</span>
											<span class="greennumbertext">
												<span
													v-if="i.numberOfSections < 10"
													class="greennumbertext"
													>0{{ i.numberOfSections }}</span
												>
												<span v-else class="greennumbertext">{{
													i.numberOfSections
												}}</span>
											</span>
										</div>
										<div class="d-flex flex-column">
											<span class="tp-cardhead">Candidates</span>
											<span style="text-align: center">
												<span
													v-if="i.candidateCount < 10"
													class="bluenumbertext"
													>0{{ i.candidateCount }}</span
												>
												<span v-else class="bluenumbertext">{{
													i.candidateCount
												}}</span>
											</span>
										</div>
										<div class="d-flex flex-column">
											<span class="tp-cardhead ml-3">Marks</span>
											<span class="yellownumbertext" style="text-align: center">
												<span v-if="i.marks < 10" class="yellownumbertext"
													>0{{ i.marks }}</span
												>
												<span v-else class="yellownumbertext">{{
													i.marks
												}}</span>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="ml-3 mt-2 d-flex justify-content-end">
						<b-button
							:disabled="Object.keys(selectedtest).length === 0"
							class="addbtn pl-3 pr-3"
							@click="gotoparticulartestdetails()"
							>Activate Test</b-button
						>
					</div>
				</b-modal>
				<div class="d-flex">
					<div class="autosec-sub-container">
						<div class="autosec-subhead-container">
							<b-row>
								<b-col cols="4">
									<div class="topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>Test Name &nbsp;<span class="asterik">*</span></label
										>
										<b-form-input
											class="inputField"
											id="input-1"
											autofocus
											v-model="getAutGenData.testName"
											type="text"
											placeholder="Enter here"
											:class="{
												error: $v.getAutGenData.testName.$error,
											}"
										></b-form-input>
										<div
											class="validationicon"
											v-if="
												$v.getAutGenData.testName.$dirty &&
													!$v.getAutGenData.testName.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="validationicon"
											v-if="
												!$v.getAutGenData.testName.maxLength &&
													$v.getAutGenData.testName.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col cols="4">
									<div class="topDiv mt-3 relativeclass">
										<label class="disabledfieldsetStyle">No of sections</label>
										<b-form-input
											class="disabledinputField"
											id="input-1"
											v-model="getAutGenData.sections.length"
											type="text"
											placeholder="Enter here"
											disabled
										></b-form-input>
									</div>
								</b-col>

								<b-col cols="1"></b-col>
								<b-col
									v-if="roles.includes('PUSH_AUTO_SECTION')"
									cols="3"
									class="d-flex align-items-center justify-content-end mt-3"
								>
									<b-button
										class="autotest-addsecbtn mr-4"
										@click="openSectionmodal()"
										:disabled="isComplete == false"
									>
										<img
											src="../../assets/plusicon.svg"
											alt=""
											class="mr-2 mb-1"
										/>
										<span class="">Add Section</span>
									</b-button>
								</b-col>
							</b-row>
						</div>
						<div class="ags-outer-overflow p-3" id="scrollTobottom">
							<div v-for="(i, index) in getAutGenData.sections" :key="index">
								<div v-if="!i.cardClose">
									<div v-if="!i.editSecName">
										<div
											class="ags-grey-top pointer mt-1 d-flex align-items-center justify-content-between position-relative"
											style="padding: 17px 10px 17px 10px"
											@click="sectioncardOpen(index)"
										>
											<div class="ags-white-test pr-4">
												<span v-b-popover.hover.top="i.name">
													{{ i.name | filetrEmailsEditGroup }}
												</span>

												<img
													v-if="roles.includes('PUT_AUTO_SECTION')"
													v-b-popover.hover.top="'Edit'"
													@click.stop="editName(index)"
													class="ml-3 pointer"
													src="../../assets/whitePencil.svg"
													alt=""
												/>
											</div>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div
													class="mr-4 d-flex ags-validation-pos"
													v-if="i.sectionValidationShow"
												>
													<img
														src="../../assets/section-validation.svg"
														alt=""
														class="mr-2"
													/>
													<div class="section-validation-text mt-1">
														Please fill all required fields
													</div>
												</div>
												<div
													class="mr-3"
													:class="i.addTypeDisable ? 'disableAddtype' : ' '"
													:disabled="i.addTypeDisable"
													@click.stop="i.addTypeDisable ? '' : addTypes(index)"
												>
													<span class="d-flex align-items-center">
														<span>
															<img
																src="../../assets/whiteAdd.svg"
																alt=""
																class="mr-2"
															/>
														</span>
														<span class="ags-whiteunderline"> Add Types </span>
													</span>
												</div>

												<img
													v-if="roles.includes('DELETE_AUTO_SECTION')"
													v-b-popover.hover.top="'Delete'"
													src="../../assets/sectionDelete.svg"
													@click.stop="deleteSection(index)"
													alt=""
													class="mr-3 pointer"
												/>
												<div
													class="d-flex align-items-center justify-content-end mr-3"
												>
													<img src="../../assets/sectionuparrow.svg" alt="" />
												</div>
											</div>
										</div>
									</div>

									<div v-else>
										<div
											class="ags-grey-top pointer mt-1 d-flex align-items-center justify-content-between position-relative"
											style="padding: 9px 10px"
										>
											<div
												style="width: 50%"
												:class="
													i.editName.length <= 128 &&
													i.editName.length != 0 &&
													!i.editError
														? 'topDiv relativeclass ags-bottom-border'
														: 'topDiv relativeclass ags-bottom-border-red'
												"
											>
												<div>
													<b-form-input
														autofocus
														id="input-1"
														type="text"
														placeholder="Enter section name"
														v-model="i.editName"
														v-on:keyup.enter="editsectionName(index)"
													></b-form-input>
													<div
														class="ags-text-count"
														v-if="i.editName.length <= 128"
													>
														{{ i.editName.trim().length }} / 128
													</div>
													<div class="ags-red-text-count" v-else>
														{{ i.editName.trim().length }} / 128
													</div>
												</div>

												<img
													v-if="
														i.editName.length <= 128 &&
															i.editName.length != 0 &&
															!i.editError
													"
													@click="editsectionName(index)"
													class="editSectionsvg pointer"
													src="../../assets/editSectionName.svg"
													alt=""
												/>
												<img
													v-else
													class="editSectionsvg"
													src="../../assets/redEdit.svg"
													alt=""
													id="ags-popover-id"
												/>
											</div>

											<div>
												<div
													class="d-flex align-items-center justify-content-between"
												>
													<div
														class="mr-4 d-flex ags-validation-pos"
														v-if="i.sectionValidationShow"
													>
														<img
															src="../../assets/section-validation.svg"
															alt=""
															class="mr-2"
														/>
														<div class="section-validation-text mt-1">
															Please fill all required fields
														</div>
													</div>

													<b-popover
														:show="i.editName == ''"
														target="ags-popover-id"
													>
														<div class="d-flex align items center">
															<div>
																<img
																	src="../../assets/yellowAlert.svg"
																	alt=""
																/>
															</div>
															<div class="pop-head-text ml-2 mt-1">
																Section name is required
															</div>
														</div>
													</b-popover>

													<b-popover
														:show="i.editName.length > 128"
														target="ags-popover-id"
													>
														<div class="d-flex align items center">
															<div>
																<img
																	src="../../assets/yellowAlert.svg"
																	alt=""
																/>
															</div>
															<div class="pop-head-text ml-2 mt-1">
																Should not exceed 128 characters.
															</div>
														</div>
													</b-popover>
													<b-popover
														:show="i.editError"
														target="ags-popover-id"
													>
														<div class="d-flex align-items-center">
															<img src="../../assets/yellowAlert.svg" alt="" />
															<div class="pop-head-text ml-2 mt-1">
																Section name already exists
															</div>
														</div>
													</b-popover>
												</div>
											</div>

											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div
													class="mr-3"
													:class="i.addTypeDisable ? 'disableAddtype' : ''"
													:disabled="i.addTypeDisable"
													@click.stop="i.addTypeDisable ? '' : addTypes(index)"
												>
													<span class="d-flex align-items-center">
														<span>
															<img
																src="../../assets/whiteAdd.svg"
																alt=""
																class="mr-2"
															/>
														</span>
														<span class="ags-whiteunderline"> Add Types </span>
													</span>
												</div>

												<img
													v-if="roles.includes('DELETE_AUTO_SECTION')"
													v-b-popover.hover.top="'Delete'"
													src="../../assets/sectionDelete.svg"
													@click.stop="deleteSection(index)"
													alt=""
													class="mr-3 pointer"
												/>
												<div
													class="d-flex align-items-center justify-content-end mr-3"
												>
													<img src="../../assets/sectionuparrow.svg" alt="" />
												</div>
											</div>
										</div>
									</div>

									<div class="ags-white-bottom">
										<b-row class="mt-4">
											<b-col cols="4">
												<div class="topDiv" ref="autogenerateoptions'">
													<label class="fieldsetStyle sharelabel"
														>Difficulty Level<span
															v-if="i.typedistributeRandomly"
															class="asterik"
															>*</span
														></label
													>
													<div
														:class="
															i.typeDifficultyLevel.length == 0 &&
															i.typedistributeRandomly &&
															i.distributerandomly == true
																? 'ags-dropdown-diffy-error pointer'
																: i.typedistributeRandomly
																? 'ags-dropdown-diffy pointer'
																: 'ags-inactive '
														"
														class="d-flex justify-content-between"
														v-closeArray="{
															index,
															property: 'typediffrequired',
															array: getAutGenData.sections,
															handler: handletypediffrequired(index),
														}"
														@click="i.typediffrequired = !i.typediffrequired"
													>
														<span v-if="i.typeDifficultyLevel.length != 0">
															<span>
																Difficulty Level
																<span
																	v-for="(value,
																	index) in i.typeDifficultyLevel"
																	:key="index"
																>
																	{{ value }}
																	<span
																		v-if="
																			index !== i.typeDifficultyLevel.length - 1
																		"
																		>,</span
																	>
																</span>
															</span>
														</span>
														<span v-else>Choose Options</span>

														<span
															><img
																src="../../assets/carrotdown.svg"
																alt=""
																class="mr-1"
														/></span>
													</div>
													<div
														style="position: absolute; top: 5px; right: 35px"
														v-if="
															$v.getAutGenData.sections.$each[index]
																.typeDifficultyLevel &&
																i.typedistributeRandomly &&
																i.typeDifficultyLevel.length == 0 &&
																i.distributerandomly == true
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
													<div
														v-if="
															i.typediffrequired && i.typedistributeRandomly
														"
														@click.stop=""
														class="qb-dropdown-option-add d-flex"
													>
														<b-form-group class="qb-dd-group">
															<b-form-checkbox-group
																class="ags-add-drop"
																v-model="i.typeDifficultyLevel"
																@change="updateSecvalidation(index)"
																:options="diffoptions"
																stacked
																buttons
															></b-form-checkbox-group>
														</b-form-group>
													</div>
												</div>
											</b-col>
											<b-col>
												<div class="ags-checkBox">
													<b-form-checkbox
														class="mt-2 checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="i.typedistributeRandomly"
														@change="
															removeDifficultyLevel(),
																(i.typediffrequired = false)
														"
													>
														<div class="">
															Same Difficulty Level for all Types
														</div>
													</b-form-checkbox>
												</div>
											</b-col>
										</b-row>
										<b-row class="mt-4" v-for="(j, k) in i.types" :key="k">
											<b-col cols="3">
												<div class="topDiv">
													<label class="fieldsetStyle sharelabel"
														>Types<span class="asterik">*</span>
													</label>
													<div
														:class="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].type.$error
																? 'error-auto'
																: ' qb-dropdown-diffy d-flex justify-content-between pointer  '
														"
														v-closeArray="{
															k,
															property: 'qbdropdiff',
															array: i.types,
															handler: handleCloseqbdropdiff(index, k),
														}"
														@click.stop="
															(j.qbdropdiff = !j.qbdropdiff),
																closeqbdropdiff(index, k)
														"
													>
														<span v-if="j.type != '' && j.type == 'ALL'">
															All</span
														>
														<span v-if="j.type != '' && j.type == 'MAFO'">
															MTF</span
														>

														<span v-if="j.type != '' && j.type == 'MCQU'">
															MCQ</span
														>

														<span v-if="j.type != '' && j.type == 'LONG'">
															Descriptive</span
														>

														<span v-else-if="j.type == ''">Select Type</span>

														<span class="ags-drp-down"
															><img
																src="../../assets/carrotdown.svg"
																alt=""
																class="mr-1"
														/></span>
													</div>
													<div
														v-if="j.qbdropdiff"
														class="qb-dropdown-option-add d-flex autogentypes quesdropdown"
														@click.stop=""
													>
														<b-form-group class="">
															<b-form-radio-group
																v-model="j.type"
																class="ags-add-drop"
																id="btn-radios-3"
																:options="i.questiontype_options"
																@change="
																	disableType(index, k),
																		updatevalidation(index, k)
																"
																name="radio-btn-stacked"
																buttons
																stacked
															></b-form-radio-group>
														</b-form-group>
													</div>
													<div
														style="position: absolute; top: 5px; right: 30px"
														v-if="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].type.$error
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
												</div>
											</b-col>
											<b-col cols="2">
												<div class="topDiv relativeclass">
													<label class="fieldsetStyle"
														>Questions Count &nbsp;<span class="asterik"
															>*</span
														></label
													>
													<b-form-input
														class="ags-inputField"
														id="input-1"
														type="number"
														placeholder="Enter here"
														v-model="j.count"
														min="0"
														max="99"
														@keypress="validateKeyPress"
														@input="updatevalidation(index, k)"
														:class="{
															error:
																$v.getAutGenData.sections.$each[index].types
																	.$each[k].count.$error,
														}"
													></b-form-input>
													<div
														style="position: absolute; top: 5px; right: 30px"
														v-if="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].count.$error
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
													<div
														style="position: absolute; top: 5px; right: 30px"
														v-if="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].count.$error &&
																!$v.getAutGenData.sections.$each[index].types
																	.$each[k].count.between
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Should be between(1, 100)',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
												</div>
											</b-col>
											<b-col cols="3">
												<div class="topDiv position-relative">
													<label class="fieldsetStyle sharelabel"
														>Question Tags</label
													>
													<div
														class="qb-dropdown-diffy d-flex justify-content-between pointer"
														v-closeArray="{
															k,
															property: 'questionTagOpen',
															array: i.types,
															handler: handlequestionTagOpen(index, k),
														}"
														@click.stop="
															(j.questionTagOpen = !j.questionTagOpen),
																closequestionTagOpen(index, k)
														"
													>
														<span
															class="cj-noofrecoption"
															v-if="j.questionTags.length != 0"
														>
															{{ j.questionTags.length }}
															question tags selected
														</span>
														<span class="cj-noofrecoption" v-else>
															Select Tags(s)..</span
														>

														<span
															><img
																src="../../assets/carrotdown.svg"
																alt=""
																class="mr-1"
														/></span>
													</div>
													<div
														class="ags-tags"
														v-if="j.questionTagOpen"
														@click.stop=""
													>
														<b-form-group class="w-100">
															<b-form-checkbox
																button
																class="ags-add-drop m-1 pointer d-flex flex-column flex-nowrap"
																v-for="(option, k) in questionTagsOption"
																:key="k"
																:value="option"
																v-model.trim="j.questionTags"
																@change="selectQuestTag()"
																name="flavour-4a"
															>
																{{ option }}
															</b-form-checkbox>
														</b-form-group>
														<div v-if="questionTagsOption.length == 0">
															No question tags found
														</div>
													</div>
												</div>
											</b-col>
											<b-col cols="3">
												<div class="topDiv">
													<label class="fieldsetStyle sharelabel"
														>Difficulty Level
														<span
															v-if="
																j.type != '' &&
																	i.typedistributeRandomly == false
															"
															class="asterik"
															>*</span
														></label
													>
													<div
														:class="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].diffLevel.$error &&
															j.type != '' &&
															i.typedistributeRandomly == false
																? 'ags-dropdown-diffy-error pointer '
																: j.type != '' &&
																  i.typedistributeRandomly == false
																? 'ags-dropdown-diffy pointer'
																: 'ags-inactive'
														"
														class="d-flex justify-content-between"
														v-closeArray="{
															k,
															property: 'diffLevelrequired',
															array: i.types,
															handler: handleClosediffLevelrequired(index, k),
														}"
														@click="
															(j.diffLevelrequired = !j.diffLevelrequired),
																closediffLevelrequired(index, k)
														"
													>
														<span v-if="i.typeDifficultyLevel.length != 0">
															<span>
																Difficulty Level
																<span
																	v-for="(value,
																	index) in i.typeDifficultyLevel"
																	:key="index"
																>
																	{{ value }}
																	<span
																		v-if="
																			index !== i.typeDifficultyLevel.length - 1
																		"
																		>,</span
																	>
																</span>
															</span>
														</span>

														<span v-else-if="j.diffLevel.length != 0">
															<span>
																Difficulty Level
																<span
																	v-for="(value, index) in j.diffLevel"
																	:key="index"
																>
																	{{ value }}
																	<span v-if="index !== j.diffLevel.length - 1"
																		>,</span
																	>
																</span>
															</span>
														</span>
														<span v-else>Choose Options</span>

														<span
															><img
																src="../../assets/carrotdown.svg"
																alt=""
																class="mr-1"
														/></span>
													</div>
													<div
														style="position: absolute; top: 5px; right: 35px"
														v-if="
															$v.getAutGenData.sections.$each[index].types
																.$each[k].diffLevel.$error &&
																j.type != '' &&
																i.typedistributeRandomly == false
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
													<div
														v-if="
															j.diffLevelrequired &&
																i.typedistributeRandomly == false &&
																j.type != ''
														"
														class="qb-dropdown-option-add d-flex"
														@click.stop=""
													>
														<b-form-group
															class="qb-dd-group"
															v-if="j.type == 'MCQU'"
														>
															<b-form-checkbox-group
																class="ags-add-drop"
																v-model="j.diffLevel"
																:options="i.mcqdiffoptions"
																@change="updatevalidation(index, k)"
																buttons
																stacked
															></b-form-checkbox-group>
														</b-form-group>
														<b-form-group
															class="qb-dd-group"
															v-if="j.type == 'MAFO'"
														>
															<b-form-checkbox-group
																class="ags-add-drop"
																v-model="j.diffLevel"
																:options="i.mtfdiffoptions"
																@change="updatevalidation(index, k)"
																buttons
																stacked
															></b-form-checkbox-group>
														</b-form-group>
														<b-form-group
															class="qb-dd-group"
															v-if="j.type == 'LONG'"
														>
															<b-form-checkbox-group
																class="ags-add-drop"
																v-model="j.diffLevel"
																:options="i.longdiffoptions"
																@change="updatevalidation(index, k)"
																buttons
																stacked
															></b-form-checkbox-group>
														</b-form-group>
														<b-form-group
															class="qb-dd-group"
															v-if="j.type == 'ALL'"
														>
															<b-form-checkbox-group
																class="ags-add-drop"
																v-model="j.diffLevel"
																:options="i.alldiffoptions"
																@change="updatevalidation(index, k)"
																buttons
																stacked
															></b-form-checkbox-group>
														</b-form-group>
													</div>
												</div>
												<span
													v-if="j.type == '' || j.type == null"
													class="autogen-enabling-text"
													>Select 'Type' to enable 'Difficulty Level'
													<span class="asterik">*</span></span
												>
											</b-col>
											<b-col
												cols="1"
												v-if="roles.includes('DELETE_AUTO_SECTION')"
											>
												<img
													v-if="i.types.length > 1"
													v-b-popover.hover.top="'Delete'"
													src="../../assets/deleteicon.svg"
													@click="deleteType(index, k)"
													alt=""
													class="mr-3 pointer"
												/>
											</b-col>
										</b-row>
									</div>
								</div>
								<div
									v-else
									class="ags-grey-top pointer mt-1 p-3 d-flex align-items-center justify-content-between position-relative"
									style="padding: 17px 10px 17px 10px"
									@click="sectioncardClose(index)"
								>
									<div class="ags-white-test pr-4">
										<span v-b-popover.hover.top="i.name">
											{{ i.name | filetrEmailsEditGroup }}
										</span>
										<img
											v-if="roles.includes('PUT_AUTO_SECTION')"
											v-b-popover.hover.top="'Edit'"
											@click="openCard(index)"
											class="ml-3 pointer"
											src="../../assets/whitePencil.svg"
											alt=""
										/>
									</div>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div
											class="d-flex align-items-center ags-alert-pos"
											v-if="i.name == ''"
										>
											<div>
												<img src="../../assets/yellowAlert.svg" alt="" />
											</div>
											<div class="pop-head-text ml-2">
												Section Name is required
											</div>
										</div>

										<div
											class="mr-4 d-flex ags-validation-pos"
											v-if="i.sectionValidationShow == true"
										>
											<img
												src="../../assets/section-validation.svg"
												alt=""
												class="mr-2"
											/>
											<div class="section-validation-text mt-1">
												Please fill all required fields
											</div>
										</div>
										<div
											class="mr-3"
											:class="i.addTypeDisable ? 'disableAddtype' : ''"
											:disabled="i.addTypeDisable"
											@click.stop="i.addTypeDisable ? '' : addTypes(index)"
										>
											<span class="d-flex align-items-center">
												<span>
													<img
														src="../../assets/whiteAdd.svg"
														alt=""
														class="mr-2"
													/>
												</span>
												<span class="ags-whiteunderline"> Add Types </span>
											</span>
										</div>

										<img
											v-if="roles.includes('DELETE_AUTO_SECTION')"
											v-b-popover.hover.top="'Delete'"
											src="../../assets/sectionDelete.svg"
											@click.stop="deleteSection(index)"
											alt=""
											class="mr-3 pointer"
										/>
										<div
											class="d-flex align-items-center justify-content-end mr-2"
										>
											<img src="../../assets/sectiondownarrow.svg" alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="autosec-right-container ml-2">
						<span class="testconfighead mt-2">Total Questions</span>

						<div
							class="p-2 auto-diff"
							v-for="(data, index) in autoQuestionsDetails[0]"
							:key="index"
						>
							<div class="testconfighead">
								<span v-if="index == 'license'">All</span>
								<span v-else>{{ index }}</span>
							</div>
							<div class="auto-diff-header d-flex justify-content-center">
								<div class="auto-diff-header-div1 text-center p-2">Level</div>
								<div class="auto-diff-header-div text-center p-2">1</div>
								<div class="auto-diff-header-div text-center p-2">2</div>
								<div class="auto-diff-header-div text-center p-2">3</div>
								<div class="auto-diff-header-div text-center p-2">4</div>
								<div class="auto-diff-header-div text-center p-2">5</div>
							</div>
							<div v-for="(data1, index1) in data" :key="index1">
								<div v-for="(data2, index3) in data1" :key="index3">
									<div
										class="auto-diff-body d-flex justify-content-center mt-1"
										v-if="index3 != 'FIBL'"
									>
										<div class="auto-diff-type text-center p-2">
											<span v-if="index3 == 'MCQU'">MCQ</span>
											<span v-if="index3 == 'MAFO'">MTF</span>
											<span v-if="index3 == 'LONG'">LONG</span>
										</div>
										<div
											class="auto-diff-body-type text-center p-2"
											v-for="(data3, index) in data2"
											:key="index"
										>
											<span>{{ data3 }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="modal-1"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="md"
		>
			<div class="modalheading">Add Section</div>
			<div @click="closesectionmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<b-row
				><b-col cols="12">
					<div class="topDiv mt-3 relativeclass">
						<label class="fieldsetStyle"
							>Section Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							class="inputField"
							:class="{ error: $v.name.$error || duplicateError }"
							v-on:keyup.enter="onEnter(name)"
							v-model.trim="$v.name.$model"
							id="input-1"
							type="text"
							autofocus
							placeholder="Enter here"
						></b-form-input>
						<div
							class="validationicon"
							v-if="$v.name.$dirty && !$v.name.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="!$v.name.maxLength && $v.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationicon"
							v-if="duplicateError"
							v-b-popover.hover.top.v-danger="{
								content: 'Section name already exists',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>
			<div></div>
			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn" @click="saveSection()">Save</b-button>
			</div>
		</b-modal>
		<b-modal
			id="typedisterror"
			centered
			no-close-on-backdrop
			hide-footer
			hide-header
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('typedisterror')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="caution-modal-text">
				If Type Distribute randomly is not selected then you can add only 2
				'MTF','MCQ' type or you can add 1 'ALL' type.
			</div>
			<div class="d-flex justify-content-start mt-3">
				<b-button
					@click="$bvModal.hide('typedisterror')"
					class="addbtn mr-2 pl-3 pr-3"
					>Ok</b-button
				>
			</div>
		</b-modal>
	</div>
</template>

<script>
import {
	required,
	maxLength,
	helpers,
	between,
	requiredIf,
} from "vuelidate/lib/validators";
import toast from "../mixin/toast";
import { mapGetters } from "vuex";

import {
	AutogenDatabankTable,
	getAllQuestionTags,
} from "../../utils/apiFunctions";
export default {
	name: "AutogenerateSection",
	mixins: [toast],
	data() {
		return {
			duplicateError: false,
			sectiontypedistributeRandomly: false,
			sectionvalidIndex: null,
			validtypeIndex: null,
			typedifflevel: false,
			// isChecked: false,
			sectionValidationShow: false,
			qbdropadd: false,
			selectedIndex: null,
			toggleToggleQustionTags: false,
			cardid: "",
			totalnoofquestions: "",
			showdiffoptions: false,
			index: 25,
			atclicktype: false,
			isCompleted: false,
			qbdropdiff: false,
			showansweroptions: false,
			atclicktopic: false,
			showEdit: null,
			number_of_question: 0,
			topic_type: false,
			updatebtn: false,
			valueofType: "",
			// assignIndex:{
			//   sectionIndex:"",
			//   sectionIndex:"",

			// },

			ifAll: false,
			// show: true,
			topic_form: [],
			diffselected: [],
			questionTagsOption: [],
			selectedTag: [],
			allSelectedQuestionTags: [],
			autoQuestionsDetails: {},
			updateData: null,
			force: null,
			activetest: [],
			selectedtest: {},

			updatedataoptions: [
				{
					item: false,
					name: "Activate the Test",
				},
				{
					item: true,
					name: "Add New Test",
				},
			],
			Q_options: [
				{ text: "ALL", value: "ALL", disabled: false },
				{ text: "MCQ", value: "MCQU", disabled: false },
				{ text: "MTF", value: "MAFO", disabled: false },
				{ text: "Descriptive", value: "LONG", disabled: false },
			],
			diffoptions: [
				{
					disabled: false,
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					disabled: false,
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					disabled: false,
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					disabled: false,
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					disabled: false,
					value: "5",
					text: "Difficulty Level 5",
				},
			],
			testName: "",
			active: false,
			testID: "",
			type_form: [],
			visible: "",
			name: "",
			sectionnumber: 0,
			sections: [],

			noofquestion: null,
			show: true,
			type: false,
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			questiontype_options: [
				{ text: "ALL", value: "ALL", disabled: false },
				{ text: "MCQ", value: "MCQU", disabled: false },
				{ text: "MTF", value: "MAFO", disabled: false },
				{ text: "Descriptive", value: "LONG", disabled: false },
			],
		};
	},

	validations() {
		return {
			name: {
				required,
				maxLength: maxLength(128),
			},
			getAutGenData: {
				sections: {
					$each: {
						name: {
							required,
							maxLength: maxLength(128),
						},

						typeDifficultyLevel: {
							required: requiredIf(function() {
								return this.sectiontypedistributeRandomly;
							}),
						},

						types: {
							$each: {
								type: {
									required,
								},
								count: {
									required,
									alpha: helpers.regex("alpha", /^\d+$/i),
									between: between(1, 100),
								},
								diffLevel: {
									required: requiredIf(function() {
										return this.sectiontypedistributeRandomly === false;
									}),
								},
							},
						},
					},
				},
				testName: {
					required,
					maxLength: maxLength(128),
				},
			},

			testName: {
				required,
				maxLength: maxLength(128),
			},
		};
	},
	watch: {},
	beforeUpdate() {
		for (let i in this.sections) {
			let total = 0;
			let noOfTypes = 0;
			let m = 0;
			let n = 0;
			let simp;
			for (let j in this.sections[i].types) {
				simp = parseInt(this.sections[i].types[j].count);
				if (!isNaN(simp)) {
					total += simp;
				} else {
					total += 0;
				}
				if (this.sections[i].types[j].type == "MCQU") {
					m = 1;
				} else if (this.sections[i].types[j].type == "MAFO") {
					n = 1;
				} else if (this.sections[i].types[j].type == "ALL") {
					n = 1;
					m = 1;
				}
				noOfTypes = m + n;
				this.sections[i].noOfTypes = noOfTypes;
				this.sections[i].noOfQuestions = total;
			}
		}
	},
	created() {
		this.generateSections();

		this.getAutogenDatabankTable();
		this.getQuestionTags();
	},
	computed: {
		...mapGetters("autotestVUEX", {
			getAutGenData: "getAutGenData",
		}),
		containerHeight() {
			const recordHeight = 50;
			const minHeight = 100;
			const numRecords = this.activetest.length;
			const calculatedHeight = numRecords * recordHeight + minHeight + "px";
			return calculatedHeight;
		},

		sectionValidation() {
			for (let i in this.getAutGenData.sections) {
				for (let j in this.getAutGenData.sections[i].types) {
					const currentType = this.getAutGenData.sections[i].types[j];
					const isDistributedRandomly = this.getAutGenData.sections[i]
						.typedistributeRandomly;

					const isValid =
						currentType.type !== "" &&
						currentType.count !== null &&
						(isDistributedRandomly
							? currentType.diffLevel != null
							: currentType.diffLevel.length > 0);

					if (!isValid) {
						return false;
					}
				}
				if (this.getAutGenData.sections[i].editSecName) {
					return false;
				}
			}
			return true;
		},

		isComplete() {
			let temp;
			for (let i in this.sections) {
				for (let j in this.sections[i].types) {
					if (!this.sections[i].typedistributeRandomly) {
						if (
							this.sections[i].types[j].type == "" ||
							this.sections[i].types[j].count == null ||
							this.sections[i].typeDifficultyLevel.length == 0
						) {
							temp = false;
						} else {
							temp = true;
						}
					} else if (
						this.sections[i].types[j].type == "" ||
						this.sections[i].types[j].count == null ||
						this.sections[i].types[j].diffLevel == null
					) {
						temp = false;
					} else {
						temp = true;
					}
				}
			}
			return temp;
		},
		...mapGetters("autotestVUEX", {
			topicID: "getAutoTopicID",
		}),
		...mapGetters(["roles"]),
	},
	methods: {
		validateKeyPress(event) {
			const charCode = event.keyCode;

			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}

			const inputValue = event.target.value + String.fromCharCode(charCode);
			if (inputValue.length > 2) {
				event.preventDefault();
			}
		},
		handleCloseqbdropdiff(index, k) {
			return () => {
				this.getAutGenData.sections[index].types[k].qbdropdiff = false;
			};
		},
		handletypediffrequired(index) {
			return () => {
				this.getAutGenData.sections[index].typediffrequired = false;
			};
		},
		handleClosediffLevelrequired(index, k) {
			return () => {
				this.getAutGenData.sections[index].types[k].diffLevelrequired = false;
			};
		},
		handlequestionTagOpen(index, k) {
			return () => {
				this.getAutGenData.sections[index].types[k].questionTagOpen = false;
			};
		},

		closequestionTagOpen(index, k) {
			this.getAutGenData.sections[index].typediffrequired = false;

			this.getAutGenData.sections[index].types[k].diffLevelrequired = false;

			this.getAutGenData.sections[index].types[k].qbdropdiff = false;

			for (let i = 0; i < this.getAutGenData.sections.length; i++) {
				for (let j = 0; j < this.getAutGenData.sections[i].types.length; j++) {
					if (i !== index || j !== k) {
						this.getAutGenData.sections[i].types[j].questionTagOpen = false;
						this.getAutGenData.sections[i].types[j].diffLevelrequired = false;

						this.getAutGenData.sections[i].types[j].qbdropdiff = false;
						this.getAutGenData.sections[i].typediffrequired = false;
					}
				}
			}
		},
		closeqbdropdiff(index, k) {
			this.getAutGenData.sections[index].typediffrequired = false;

			this.getAutGenData.sections[index].types[k].questionTagOpen = false;
			this.getAutGenData.sections[index].types[k].diffLevelrequired = false;

			for (let i = 0; i < this.getAutGenData.sections.length; i++) {
				for (let j = 0; j < this.getAutGenData.sections[i].types.length; j++) {
					if (i !== index || j !== k) {
						this.getAutGenData.sections[i].types[j].qbdropdiff = false;
						this.getAutGenData.sections[i].types[j].questionTagOpen = false;
						this.getAutGenData.sections[i].typediffrequired = false;

						this.getAutGenData.sections[i].types[j].diffLevelrequired = false;
					}
				}
			}
		},
		closediffLevelrequired(index, k) {
			this.getAutGenData.sections[index].typediffrequired = false;

			this.getAutGenData.sections[index].types[k].qbdropdiff = false;
			this.getAutGenData.sections[index].types[k].questionTagOpen = false;

			for (let i = 0; i < this.getAutGenData.sections.length; i++) {
				for (let j = 0; j < this.getAutGenData.sections[i].types.length; j++) {
					if (i !== index || j !== k) {
						this.getAutGenData.sections[i].types[j].diffLevelrequired = false;
						this.getAutGenData.sections[i].types[j].qbdropdiff = false;

						this.getAutGenData.sections[i].types[j].questionTagOpen = false;
						this.getAutGenData.sections[i].typediffrequired = false;
					}
				}
			}
		},

		scrollToBottom() {
			this.$nextTick(() => {
				const scrollContainer = document.getElementById("scrollTobottom");

				scrollContainer.scrollBy({
					top: 999,
					behavior: "smooth",
				});
			});
		},
		updatevalidation(index, k) {
			this.validtypeIndex = k;
			if (
				(this.getAutGenData.sections[index].types[k].type !== " " &&
					this.getAutGenData.sections[index].types[k].count !== "" &&
					this.getAutGenData.sections[index].types[k].diffLevel.length !== 0) ||
				(this.getAutGenData.sections[index].types[k].type !== " " &&
					this.getAutGenData.sections[index].types[k].count !== "" &&
					this.getAutGenData.sections[index].typeDifficultyLevel.length !== 0)
			) {
				this.getAutGenData.sections[index].sectionValidationShow = false;
			}
		},
		updateSecvalidation(index) {
			if (
				this.getAutGenData.sections[index].typeDifficultyLevel.length !== 0 &&
				this.getAutGenData.sections[index].types[this.validtypeIndex].type !=
					"" &&
				this.getAutGenData.sections[index].types[this.validtypeIndex].count !=
					""
			) {
				this.getAutGenData.sections[index].sectionValidationShow = false;
			}
		},
		openSectionmodal() {
			if (this.getAutGenData.sections.length > 4) {
				this.errorToast("You cannot add more than 5 sections");
			} else {
				this.$v.$reset();
				this.name = "";
				this.$bvModal.show("modal-1");
			}
		},
		openCard(index) {
			this.getAutGenData.sections[index].cardClose = true;
			this.getAutGenData.sections[index].editSecName = true;
		},
		sectioncardClose(index) {
			this.getAutGenData.sections[index].cardClose = false;
			this.$forceUpdate();
		},

		sectioncardOpen(index) {
			this.getAutGenData.sections[index].cardClose = true;
			this.$forceUpdate();
		},

		disableType(index, k) {
			if (this.getAutGenData.sections[index].types[k].type != "") {
				this.getAutGenData.sections[index].types[k].qbdropdiff = false;
			}
			if (this.getAutGenData.sections[index].types[k].type == "ALL") {
				this.getAutGenData.sections[index].addTypeDisable = true;
			} else if (this.getAutGenData.sections[index].types.length == 3) {
				this.getAutGenData.sections[index].addTypeDisable = true;
			} else {
				this.getAutGenData.sections[index].addTypeDisable = false;
			}
		},

		generateSections() {
			if (
				this.getAutGenData.sections.length !== this.getAutGenData.noofSections
			) {
				this.getAutGenData.sections = [];

				for (let i = 0; i < this.getAutGenData.noofSections; i++) {
					const section = {
						sectionValidationShow: false,
						distributerandomly: false,
						editName: "",
						name: "Section " + (i + 1),
						addTypeDisable: false,
						sameDifficultyLevel: false,
						types: [],
						editSecName: false,
						cardClose: false,

						typeDifficultyLevel: [],
						mcqdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
						mtfdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
						longdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
						alldiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
						noOfQuestions: this.getAutGenData.autoQuestions,
						questiontype_options: JSON.parse(
							JSON.stringify(this.questiontype_options)
						),
						typediffrequired: false,
						typedistributeRandomly: false,
					};

					this.getAutGenData.sections.push(section);

					let totalQuestions = this.getAutGenData.autoQuestions;
					const typeCount = this.getAutGenData.questiontype_options.length;
					const randomCounts = [];

					for (let j = 0; j < typeCount - 1; j++) {
						const maxCount = totalQuestions - (typeCount - 1 - j);
						const randomCount = Math.floor(Math.random() * maxCount) + 1;
						randomCounts.push(randomCount);
						totalQuestions -= randomCount;
					}
					randomCounts.push(totalQuestions);

					for (
						let k = 0;
						k < this.getAutGenData.questiontype_options.length;
						k++
					) {
						const value = this.getAutGenData.questiontype_options[k];

						if (value == "ALL") {
							this.getAutGenData.sections[i].addTypeDisable = true;
						}

						const type = {
							type: value,
							count: randomCounts[k],
							diffLevel: [],
							qbdropdiff: false,
							diffLevelrequired: false,
							questionTagOpen: false,
							questionTags: this.selectedTag,
							questionTagsOption: [],
						};

						this.getAutGenData.sections[i].types.push(type);
						this.getAutGenDataSections(section, i);
					}
				}
			}
		},
		getAutGenDataSections(section, i) {
			for (const typeObj of this.getAutGenData.sections[i].types) {
				this.getAutGenData.sections[i].noOfQuestions = typeObj.count;

				if (this.getAutGenData.sections[i].types.length > 1) {
					this.getQuestType(typeObj, section, i);
				} else {
					// Enable all options when type is 1
					section.questiontype_options.forEach((option) => {
						option.disabled = false;
					});
				}
			}
		},
		getQuestType(typeObj, section) {
			if (typeObj.type === "ALL") {
				section.questiontype_options.forEach((option) => {
					if (
						["MCQU", "MAFO", "LONG"].includes(option.value) ||
						option.value === "ALL"
					) {
						option.disabled = true;
					}
				});
			} else if (["MCQU", "MAFO", "LONG"].includes(typeObj.type)) {
				section.questiontype_options.forEach((option) => {
					if (option.value === "ALL" || option.value === typeObj.type) {
						option.disabled = true;
					}
				});
			} else {
				section.questiontype_options.forEach((option) => {
					this.getOptions(option);
				});
			}
		},
		getOptions(option) {
			if (
				option.value === "ALL" ||
				["MCQU", "MAFO", "LONG"].includes(option.value)
			) {
				option.disabled = true;
			} else {
				option.disabled = false;
			}
		},

		goTobackpage() {
			this.$router.push({
				name: "AutogenerateTest",
				query: {
					type: this.$route.query.type,
					sort: this.$route.query.sort,
				},
			});
		},
		diffAndQtag(k) {
			if (this.selectedIndex === k) {
				this.selectedIndex = null;
			} else {
				this.selectedIndex = k;
			}
		},
		showDiffOptionFunc() {
			this.showdiffoptions = false;
		},
		chaib(index) {
			this.cardid = index;
		},
		async getAutogenDatabankTable() {
			try {
				let data = {
					tags: this.allSelectedQuestionTags,
				};
				const res = await AutogenDatabankTable(data);
				if (res.status == 200) {
					this.autoQuestionsDetails = res.data.data;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		removeDifficultyLevel() {
			for (let i in this.getAutGenData.sections) {
				if (!this.getAutGenData.sections[i].typedistributeRandomly) {
					this.getAutGenData.sections[i].typeDifficultyLevel = [];
				}
			}
		},

		selectQuestTag() {
			this.allSelectedQuestionTags = [];
			for (let i in this.getAutGenData.sections) {
				for (let j in this.getAutGenData.sections[i].types) {
					this.allSelectedQuestionTags = [
						...this.allSelectedQuestionTags,
						...this.getAutGenData.sections[i].types[j].questionTags,
					];

					this.getAutGenData.sections[i].types[
						j
					].questionTagsOption = this.questionTagsOption;
				}
			}
			this.getAutogenDatabankTable();
		},

		async getQuestionTags() {
			try {
				const res = await getAllQuestionTags();
				if (res.status == 200) {
					this.questionTagsOption = res.data.data.questionTags;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		//Making inactive  in to active

		makeactive() {
			let payload = {
				portion: "AutoGenTest",
				name: this.getAutGenData.testName,
				publicAvailability: this.$route.query.available,
				active: true,
				force: false,
				sectionData: {
					sections: this.getAutGenData.sections,
				},
			};

			this.$store
				.dispatch("autotestVUEX/postAutoGenerate", payload)
				.then((res) => {
					if (res.status == 200) {
						this.testID = res.data.data.testID;

						this.$router.push({
							name: "AutoQPBuilder",
							query: {
								available: this.$route.query.available,
							},
							params: {
								topicID: this.topicID,
								testID: this.testID,
								testName: this.getAutGenData.testName,
							},
						});

						this.$bvModal.hide("testsamename");

						this.successToast("Test created successfully!");
					} else if (res.status == 404) {
						this.errorToast(res.data.data.Data);
					} else if (res.status == 409) {
						this.$bvModal.hide("testsamename");

						this.activetopic = res.data.data.test;
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
			this.$bvModal.hide("testsamename");
		},
		//Making inactive  in to active

		gotoparticularpage() {
			if (!this.updateData) {
				this.LoaderStatus = false;
				this.$bvModal.hide("testsamename");

				this.$bvModal.show("inactivetests");
			} else {
				this.LoaderStatus = false;
				this.$bvModal.show("confirmationmodal");

				this.$bvModal.hide("testsamename");
			}
		},
		//Making inactive  in to active

		gotoparticulartestdetails() {
			this.$bvModal.hide("testsamename");

			this.selectedtest.active = true;
			this.selectedtest.force = true;
			this.$store
				.dispatch("autotestVUEX/postAutoGenerate", this.selectedtest)

				.then((res) => {
					if (res.status == 200) {
						this.successToast("Test activated successfully!");

						this.testID = res.data.data.testID;

						this.$router.push({
							name: "AutoQPBuilder",
							query: {
								available: this.$route.query.available,
							},
							params: {
								topicID: this.topicID,
								testID: this.testID,
								testName: this.getAutGenData.testName,
							},
						});
						this.$bvModal.hide("inactivetests");
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
		},

		deleteSection(index) {
			this.$store.commit("autotestVUEX/deleteSection", index);
			this.successToast("Section deleted successfully!");
		},
		closesectionmodal() {
			this.$bvModal.hide("modal-1");
			this.name = "";
			this.$v.$reset();
			this.duplicateError = false;
		},
		changeAtclicktype(index) {
			this.atclicktype = !this.atclicktype;
			if (this.atclicktype) {
				this.sections[index].typeDifficultyLevel = "common";
			} else {
				this.sections[index].typeDifficultyLevel = "distinct";
			}
		},

		deleteType(k, index) {
			let assignIndex = {
				sectionIndex: k,
				typeIndex: index,
			};
			this.$store.commit("autotestVUEX/deleteType", assignIndex);
		},
		editName(index) {
			this.getAutGenData.sections[index].editSecName = true;
			this.getAutGenData.sections[index].editName = this.getAutGenData.sections[
				index
			].name;
		},

		typedifficultychange(index) {
			if (this.sections[index].typeDifficultyLevel.length == 0) {
				this.sections[index].typediffrequired = true;
			} else {
				this.sections[index].typediffrequired = false;
			}
		},

		onEnter(name) {
			this.saveSection(name);
		},
		addTypes(index) {
			this.touchAutGenDataSection(index);
			this.setSectionTypeDistributeRandomly(index);

			this.getAutGenData.sections[index].cardClose = false;
			this.getAutGenData.sections[index].distributerandomly = true;

			if (!this.$v.getAutGenData.sections.$each[index].$invalid) {
				this.getAutGenData.sections[index].distributerandomly = true;
				this.$store.commit("autotestVUEX/addTypes", index);
				this.disableQuestionTypeOptions(index);
			}
		},

		touchAutGenDataSection(index) {
			this.$v.getAutGenData.sections.$each[index].$touch();
		},

		setSectionTypeDistributeRandomly(index) {
			this.sectiontypedistributeRandomly = this.getAutGenData.sections[
				index
			].typedistributeRandomly;
		},

		disableQuestionTypeOptions(index) {
			const section = this.getAutGenData.sections[index];

			for (const option of section.questiontype_options) {
				for (const type of section.types) {
					if (option.value === type.type || option.value === "ALL") {
						option.disabled = true;
					}
				}
			}
		},

		saveSection() {
			this.$v.name.$touch();
			const trimmedName = this.name.trim().toLowerCase();
			const isDuplicate = this.getAutGenData.sections.some(
				(sec) => sec.name.trim().toLowerCase() === trimmedName
			);

			if (isDuplicate) {
				this.duplicateError = true;
				return; // don't continue
			} else {
				this.duplicateError = false;
			}
			if (!this.$v.name.$invalid) {
				const section = {
					editName: "",
					distributerandomly: false,

					sectionValidationShow: false,

					name: this.name,
					addTypeDisable: false,
					sameDifficultyLevel: false,
					cardClose: false,
					editSecName: false,

					types: [],
					typeDifficultyLevel: [],
					mcqdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					mtfdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					longdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					alldiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					noOfQuestions: null,
					questiontype_options: JSON.parse(
						JSON.stringify(this.questiontype_options)
					),
					typediffrequired: false,
					typedistributeRandomly: false,
				};

				this.getAutGenData.sections.push(section);
				this.getAutGenData.noofSections++;

				const type = {
					type: "",
					count: "",
					diffLevel: [],
					qbdropdiff: false,
					diffLevelrequired: false,
					questionTagOpen: false,
					questionTags: this.selectedTag,
					questionTagsOption: [],
				};

				// Add the default type object to the newly added section
				this.getAutGenData.sections[
					this.getAutGenData.sections.length - 1
				].types.push(type);

				this.$bvModal.hide("modal-1");
			}
			this.scrollToBottom();
		},
		addSection(secName) {
			this.$v.name.$touch();
			this.$v.sections.$touch();
			for (let i in this.sections) {
				for (let j in this.sections[i].types) {
					if (!this.sections[i].typedistributeRandomly) {
						if (this.sections[i].typeDifficultyLevel.length == 0) {
							this.sections[i].typediffrequired = true;
							this.sections[i].types[j].diffLevelrequired = false;
						}
					} else if (this.sections[i].types[j].diffLevel == null) {
						this.sections[i].types[j].diffLevelrequired = true;
						this.sections[i].typediffrequired = false;
					}
				}
			}
			if (!this.$v.name.$invalid && !this.$v.sections.$invalid) {
				this.sections.push({
					name: secName,
					typedistributeRandomly: false,
					addTypeDisable: false,
					typeDifficultyLevel: [],
					typediffrequired: false,
					noOfQuestions: 0,
					noOfTypes: 0,
					mcqdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					mtfdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					longdiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					alldiffoptions: JSON.parse(JSON.stringify(this.diffoptions)),
					questiontype_options: JSON.parse(
						JSON.stringify(this.questiontype_options)
					),
					types: [
						{
							type: null,
							count: null,
							diffLevel: null,
							qbdropdiff: false,
							diffLevelrequired: false,
							questionTagsOption: JSON.parse(JSON.stringify(this.questionTags)),
							questionTags: [],
							questionTagOpen: false,
						},
					],
				});

				this.name = "";
				this.sectionnumber += 1;
				this.cardid = this.sections.length - 1 + "sectionCard";
				this.$bvModal.hide("modal-1");
				this.$v.$reset();
			}
		},
		editsectionName(index) {
			const newName = this.getAutGenData.sections[index].editName
				.trim()
				.toLowerCase();

			// Check for empty or too long input first
			if (!newName || newName.length > 128) return;

			// Check for duplicates
			const isDuplicate = this.getAutGenData.sections.some((sec, i) => {
				return i !== index && sec.name.trim().toLowerCase() === newName;
			});

			if (isDuplicate) {
				this.$set(this.getAutGenData.sections[index], "editError", true);
				return;
			}

			// Valid case
			this.$set(this.getAutGenData.sections[index], "editError", false);
			this.getAutGenData.sections[index].name = this.getAutGenData.sections[
				index
			].editName;
			this.getAutGenData.sections[index].editSecName = false;
		},
		closetestsamename() {
			this.updateData = null;

			this.$bvModal.hide("testsamename");
		},
		createSection() {
			this.$v.getAutGenData.testName.$touch();

			this.handleCreateSection();
			if (!this.sectionValidation) {
				this.errorToast("Please fill all the Mandatory Fields");
			}
			if (!this.$v.testName.$invalid || this.sectionValidation) {
				let payload = {
					portion: "AutoGenTest",
					name: this.getAutGenData.testName,
					publicAvailability: this.$route.query.available,
					active: true,
					sectionData: { sections: this.getAutGenData.sections },
				};
				this.$store
					.dispatch("autotestVUEX/postAutoGenerate", payload)
					.then((res) => {
						if (res.status == 200) {
							this.successToast("Test created successfully");
							this.testID = res.data.data.testID;

							this.$router.push({
								name: "AutoQPBuilder",
								query: {
									available: this.$route.query.available,
								},
								params: {
									topicID: this.topicID,
									testID: this.testID,
									testName: this.getAutGenData.testName,
								},
							});
						} else if (res.status == 226) {
							this.activetest = res.data.data.test;

							if (!this.$v.getAutGenData.sections.$invalid) {
								this.$bvModal.show("testsamename");
							}
						} else if (res.status === 409) {
							this.errorToast(res.data.data.Data);
						} else {
							this.errorToast(res.data.data.Data);
						}
					})
					.catch((err) => {
						this.errorToast("Something went wrong!");
						throw err;
					});
			}
		},

		handleCreateSection() {
			for (let i in this.getAutGenData.sections) {
				for (let j in this.getAutGenData.sections[i].types) {
					this.sectionvalidIndex = i;
					this.updateDistributionFlags(i);
					this.updateTypeDiffLevelFlag(i, j);
					this.updateSectionProperties(i, j);
				}
				this.$v.getAutGenData.sections.$touch();
			}
		},

		updateDistributionFlags(i) {
			const section = this.getAutGenData.sections[i];
			if (
				section.typeDifficultyLevel.length === 0 &&
				section.typedistributeRandomly
			) {
				section.distributerandomly = true;
			} else {
				section.distributerandomly = false;
			}
		},

		updateTypeDiffLevelFlag(i, j) {
			const section = this.getAutGenData.sections[i];
			const type = section.types[j];
			this.typedifflevel =
				!section.typedistributeRandomly && type.diffLevel.length === 0;
		},

		updateSectionProperties(i, j) {
			const section = this.getAutGenData.sections[i];
			const type = section.types[j];

			section.noOfQuestions = type.count;
			section.questionTagsOption = type.type;

			if (
				type.type === "" ||
				type.count === "" ||
				section.distributerandomly ||
				this.typedifflevel
			) {
				section.sectionValidationShow = true;
			} else {
				section.sectionValidationShow = false;
			}
		},

		onSubmit(event) {
			event.preventDefault();
		},
		onReset(event) {
			event.preventDefault();
			// Reset our form values
			this.form.email = "";
			this.form.name = "";
			this.form.food = null;
			this.form.checked = [];
			// Trick to reset/clear native browser form validation state
			this.show = false;
			this.$nextTick(() => {
				this.show = true;
			});
		},
	},
};
</script>

<style scoped>
.ags-grey-top {
	background: rgba(196, 196, 196, 0.15);
	border-radius: 3px 3px 0px 0px;
	border: 1px solid rgba(114, 115, 142, 0.5);
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
}

.ags-white-bottom {
	background: #ffffff;
	border: 0.7px solid #bbc4ef;
	box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
	border-radius: 0px 0px 5px 5px;
	padding: 15px 10px;
}

.ags-white-test {
	font-size: 14px;
	font-weight: 600;
	color: #72738e;
}

.ags-whiteunderline {
	font-weight: 500;
	font-size: 13px;
	text-decoration-line: underline;

	color: #72738e;
}

.gridgreencolorDynamic {
	width: 4px;
	height: 60px;
	border-radius: 2px;
	position: absolute;
	left: -5px;
	top: -8px;
}

.section {
	position: absolute;
	top: 7px;
	right: 4%;
}

.autosec-main-container .diffdropdown {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;
	border-radius: 3px;
	color: var(--bg-tertiary);
	background: #f2f4fd;
	text-align: center;
	font-size: var(--size-13);
	padding: 8px;
}

.diffdropdown-disable {
	background: #e9ecef;
	border: 1px solid #ced4da;
	box-sizing: border-box;
	border-radius: 3px;
	color: var(--bg-tertiary);
	font-size: var(--size-13);
	padding: 8px;
}
.ags-disabledbtn {
	border-radius: 3px;
	color: #fcfcfc !important;

	background-color: lightgray;
	font-size: var(--size-13);
	cursor: default !important;

	border: 1px solid lightgray;
}
.autosec-right-container {
	width: 25%;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: calc(100vh - 165px);
	margin-top: 10px;
	overflow: auto;
}

.auto-diff-body-level {
	font-weight: 500;
	font-size: 11px;
	color: #6d6d6d;
	width: 20%;
}

.auto-diff-body-type {
	font-weight: 500;
	font-size: 14px;
	color: #84a3fe;
	width: 16%;
}

.auto-diff-header {
	background: #9293aa;
	border-radius: 8px 8px 0px 0px;
	color: white;
}

.auto-diff-header-div1 {
	width: 20%;
}

.editSectionsvg {
	position: absolute;
	right: 0;
	bottom: 7px;
}

.auto-diff-header-div {
	width: 16%;
}

.activate-options-text {
	color: #696969;
	font-weight: 500;
	font-size: 14px;
}

.auto-diff-body {
	background: #ffffff;
	border: 1px solid rgba(114, 115, 142, 0.13);
	box-shadow: 0px 0px 20px rgba(196, 196, 196, 0.1);
}

.auto-diff-type {
	background: #9293aa;
	color: white;
	width: 20%;
}

.autogen-enabling-text {
	font-size: 11px;
	color: var(--btn-border);
}

.testsamename-modal-text {
	font-weight: 400;
	font-size: 14px;
	color: #8a8b8c;
}

.testsamename-test {
	color: #3471cd;
}

.testdata-size {
	overflow: auto;
}

.inactive-selected-box {
	background: #e2e7fd;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 10px;
	font-weight: 400;
	font-size: 14px;
	color: #696969;
	margin: 5px 0;
}

.inactivecust-detail-box {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 10px;
	font-weight: 400;
	font-size: 14px;
	color: #696969;
	margin: 5px 0;
}

.flexgrid {
	display: flex;
	place-content: flex-start;
	justify-content: space-around;
}

.tp-gridcont {
	display: flex;
}

.tp-gridcard {
	background: #fbfbfb;
	border: 0.7px solid var(--bg-backgroundcolor);
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	height: 0px;
	padding: 15px;
}

.caution-option {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
}

.autogen-diff-downarrow {
	position: absolute;
	right: 0px;
	top: 9px;
}

.autogensec-drpdown {
	width: 100%;
}
</style>
<style>
.pop-head-text {
	font-weight: 400;
	font-size: 10px;
	color: #df2f3f;
}

.ags-checkBox
	.custom-checkbox.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
	top: 0.21875rem;
	left: -1.3125rem;
	width: 0.875rem;
	height: 0.875rem;
	background: #ffffff;
	border: 0.2px solid #adaaaa;
	box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.34);
	border-radius: 2px;
}

.ags-checkBox label {
	color: var(--bg-tertiary);
}

.ags-bottom-border .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	padding-right: 100px;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #72738e;
	background-color: #fff;
	border: none;
	border-bottom: 2px solid #3379b3;
}
.ags-bottom-border-red .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	padding-right: 100px;

	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #72738e;
	background-color: transparent;
	border: none;
	border-bottom: 1px solid #dd2d3d;
}
.ags-bottom-border-red .form-control:focus {
	border-color: #dd2d3d !important;
	box-shadow: none !important;
}
.ags-top-inputField::placeholder {
	color: #72738e;
}

.ags-text-count {
	position: absolute;
	right: 30px;
	color: #72738e;
	font-size: 12px;
	font-weight: 400;
	top: 9px;
}

/*******    RED    *********/

.ags-red-text-count {
	position: absolute;
	right: 30px;
	color: #dd2d3d;
	font-size: 12px;
	font-weight: 400;
	top: 9px;
}

.ags-dropdown-diffy:focus {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy:hover {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy:active {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy {
	background: #ffffff;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;

	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 8px;
}

.ags-dropdown-diffy-error {
	background: #ffffff;
	border: 1px solid red !important;

	box-sizing: border-box;

	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 8px;
}

.ags-inactive {
	background: #fafafa;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	border-radius: 3px;
	font-size: var(--size-13);
	padding: 8px;
	opacity: 0.8;
	color: #adaaaa;
}

.error-auto {
	background: #ffffff;
	border: 1px solid red !important;

	box-sizing: border-box;

	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 8px;
}

.topDiv > .ags-inactive-inputField {
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	padding: 18px 8px;
	color: #adaaaa;
	opacity: 0.8;
	background: #fafafa;
}

.section-validation-text {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 10px;
	line-height: 15px;

	color: #df2f3f;
}

.ags-outer-overflow {
	height: calc(100vh - 280px);
	overflow: auto;
}

.ags-add-drop > .btn-secondary:nth-child(2n) {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
}

.ags-add-drop > .btn-secondary:nth-child(2n-1) {
	background: #f4f4f4;
	color: #545454;
	text-align: left;
	border: none;
}

.autogentypes .form-group {
	width: 100%;
}

.ags-tags {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	margin-top: 3px;
	padding: 5px;
	position: absolute;
	z-index: 7;
	width: 100%;
	font-size: var(--size-13);
	color: #545454;
	overflow: auto;
	height: 170px;
}

.ags-validation-pos {
	position: absolute;
	right: 181px;
}

.ags-alert-pos {
	position: absolute;
	left: 663px;
}

.ags-drp-down {
	position: absolute;
	right: 9px;
	top: 9px;
}
</style>
